import { Button, Dialog, DialogContent } from '@mui/material';
import { DialogTitle, SessionReviewUI, SimpleTable } from '@shared';
import { useState } from 'react';
import { getRows } from '../../Review.utils';
import { ExamInfoTableCells } from './ExamInfoTableCells';

export function ExamInfo({ data }: { data: SessionReviewUI }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button variant='outlined' onClick={() => setIsOpen(true)}>
        Exam Info
      </Button>
      <Dialog closeAfterTransition open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle title='Exam Info' fontSize={16} onClose={() => setIsOpen(false)} />
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <SimpleTable
            noBorders
            columns={[
              { id: 'label', label: '' },
              { id: 'value', label: '' },
            ]}
            rows={getRows(data)}
            entityName={''}
            renderElems={(rowData) => {
              return <ExamInfoTableCells {...rowData} />;
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
